import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ServiceManager from 'services/ServiceManager';
import AdapterError from 'errors/AdapterError';

// 1. Define the Language interface based on your API response
export interface Language {
    Id: number;
    TwoLetterIsoCode: string;
    Name?: string;
    // Add other properties returned by your service if necessary
}

// 2. Define the return type of the hook
interface UseLanguageIdResult {
    getLanguageId: () => Promise<Language | undefined>;
}

export const useLanguageId = (): UseLanguageIdResult => {
    const { i18n } = useTranslation();

    const getLanguageId = useCallback(async (): Promise<Language | undefined> => {
        try {
            // ServiceManager call returns a response containing an array of Languages
            const { data } = await ServiceManager.commonService('getLanguages', [i18n.language]);

            // Find the language object matching the current i18n locale
            const currentLanguage = (data as Language[]).find(
                (item) => item.TwoLetterIsoCode === i18n.language,
            );

            return currentLanguage;
        } catch (err: any) {
            // Re-throw as your custom AdapterError for consistent error handling
            throw new AdapterError(err);
        }
    }, [i18n.language]);

    return { getLanguageId };
};
